.feedback {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-3);
  padding: var(--tuna-spacing-4);
  border: 1px solid var(--tuna-border-default);
  border-radius: var(--tuna-shape-borderRadius);
}

.context {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-1);
}

.contextTitle {
  margin: 0;
  font-size: var(--tuna-typography-h6-fontSize);
}

.contextSubLabel {
  margin: 0;
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-content-muted);
}

.headline:focus {
  outline: none;
}

.headline:focus-visible {
  outline: 2px solid var(--tuna-palette-primary-main);
  outline-offset: 2px;
}

.headlineText,
.score {
  margin: 0;
  font-size: var(--tuna-typography-h6-fontSize);
  font-weight: 600;
}

.split,
.block {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--tuna-spacing-2);
}

.blockTitle {
  margin: 0;
  font-size: var(--tuna-typography-body2-fontSize);
  font-weight: 600;
}

.body {
  margin: 0;
  font-size: var(--tuna-typography-body2-fontSize);
}

.roll {
  width: 100%;
}

.notes {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-1);
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: var(--tuna-typography-body2-fontSize);
}

.note {
  display: flex;
  align-items: baseline;
  gap: var(--tuna-spacing-2);
}

.mark {
  min-width: 1.5em;
  padding: 0 var(--tuna-spacing-1);
  border: 1px dashed var(--tuna-border-default);
  border-radius: var(--tuna-shape-borderRadius);
  text-align: center;
  font-weight: 600;
}

.actions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--tuna-spacing-2);
}

.actions > * {
  min-height: 44px;
}
